import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import PaginatedResponse from '../../base/paginatedResponse'

/** One search term on the admin "Unmet demand" list. */
@ObjectType()
export class AdminSearchDemandDto {
  @Field()
  term!: string

  @Field(type => Int)
  searchCount!: number

  /** Results the term's most recent search found. */
  @Field(type => Int)
  resultCount!: number

  /** resultCount / searchCount: low means searched often, found little. */
  @Field(type => Float)
  ratio!: number
}

@ObjectType()
export class AdminSearchDemandPagedResultDto extends PaginatedResponse(AdminSearchDemandDto) {
}
